import React, { memo, useMemo, useState } from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import { IconButton, TablePagination } from '@material-ui/core';
import Collapse from '@material-ui/core/Collapse';
import Box from '@material-ui/core/Box';
import PaginationActions from '../../components/UI/Tabela/PaginadaSimples/Pagination/PaginationActions';
import { useUtilStyles } from '../../helpers';
import TooltipUI from '../../components/UI/Tooltip/Tooltip';
import { TableWithAccordion } from './TabelaValidarProcessosStyle';

function getAlignOption(row, column) {
  let alignOption = row.values[column.id];
  if (column.id === 'honorariosJudiciais' || column.id === 'honorariosAmigaveis' || column.id === 'despesas') {
    alignOption = 'end';
  } else {
    alignOption = 'center';
  }
  if (!row.values[column.id] && column.showTip) {
    alignOption = 'center';
  }
  return alignOption;
}


function Row({
  row, columns, styles, columnLength,
}) {
  const [open, setOpen] = useState(false);

  const getContent = (value, column) => {
    if (column.checkbox) {
      return (
        value
      );
    }

    if (column.showTip) {
      return (
        <TooltipUI title={value} placement="bottom" interactive>
          <pre
            className={styles.overFlowText}
            style={{ maxWidth: column.maxWidth - 16 }}
          >
            {column.format && typeof value === 'number' ? column.format(value) : value}
          </pre>
        </TooltipUI>
      );
    }
    if (column.hiddenFullLine) {
      return (
        <pre
          className={styles.overFlowText}
          style={{ maxWidth: column.maxWidth - 16 }}
        >
          {column.format && typeof value === 'number' ? column.format(value) : value}
        </pre>
      );
    }
    return <pre>{column.format && typeof value === 'number' ? column.format(value) : value}</pre>;
  };

  return (
    <>
      <TableRow className={styles.tableRowRoot}>
        {columns.map((column) => {
          const value = row.values[column.id];

          const alignOption = getAlignOption(row, column);
          return (
            <TableCell
              key={column.id}
              style={{
                maxWidth: column.maxWidth,
                minWidth: column.minWidth,
                width: column.width,
              }}
            >
              <div
                style={{
                  display: 'flex',
                  justifyContent: alignOption,
                }}
              >
                {getContent(value, column)}
              </div>
            </TableCell>
          );
        })}
        <TableCell style={{ borderTop: '1px solid #e0e0e0' }}>
          <IconButton size="small" onClick={() => setOpen(!open)} style={{ color: '#034ddc' }}>
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell colSpan={columnLength} style={{ paddingBottom: 0, paddingTop: 0 }}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box>
              <div style={{ display: 'flex', flexDirection: 'row' }}>
                <div style={{ paddingLeft: '8px', marginTop: '8px', marginBottom: '8px' }}>
                  <b>CNPJ/CPF: </b>
                  {row.values.cnpjCpfDevedor}
                </div>
                <div style={{ paddingLeft: '8px', marginTop: '8px', marginBottom: '8px' }}>
                  <b>Telefone: </b>
                  {row.values.telefoneDevedor}
                </div>
                <div style={{ paddingLeft: '8px', marginTop: '8px', marginBottom: '8px' }}>
                  <b>Email: </b>
                  {row.values.emailDevedor}
                </div>
              </div>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
}

const layoutConstants = {
  LABEL_ROWS_PER_PAGE: 'Linhas por página',
  PAGINA_ANTERIOR: 'Página Anterior',
  PROXIMA_PAGINA: 'Próxima Página',
};

function TabelaValidarProcessos({
  columns = [],
  rows = [],
  size = 0,
  rowsPerPageOptions = [15, 20, 25],
  page = 0,
  rowsPerPage,
  onChangePage,
  onChangeRowsPerPage,
}) {
  const styles = useUtilStyles();

  const columnLength = useMemo(() => columns.length + 1, [columns.length]);

  const buildEmptyRows = () => {
    const emptyRows = rowsPerPage - Math.min(rowsPerPage, rows.length);

    const content = [];
    for (let i = 0; i < emptyRows; i += 1) {
      content.push(
        <TableRow key={i} style={{ height: 31 }}>
          <TableCell colSpan={columnLength}>
            <p />
          </TableCell>
        </TableRow>,
      );
    }
    return content;
  };

  return (
    <>
      <TableWithAccordion>
        <Table>
          <TableHead>
            <TableRow>
              {columns.map(column => (
                <TableCell
                  id={column.id}
                  key={column.id}
                  style={{
                    maxWidth: column.maxWidth,
                    minWidth: column.minWidth,
                    width: column.width,
                    textAlign: column.align,
                  }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map(row => (
              <Row
                key={row.id}
                row={row}
                columns={columns}
                styles={styles}
                columnLength={columnLength}
              />
            ))}
            {buildEmptyRows()}
          </TableBody>
        </Table>
      </TableWithAccordion>
      <TablePagination
        style={{ width: '100%' }}
        rowsPerPageOptions={rowsPerPageOptions}
        colSpan={columns.length}
        component="div"
        count={size}
        rowsPerPage={rowsPerPage}
        page={page}
        labelRowsPerPage={layoutConstants.LABEL_ROWS_PER_PAGE}
        backIconButtonProps={{
          'aria-label': layoutConstants.PAGINA_ANTERIOR,
        }}
        nextIconButtonProps={{
          'aria-label': layoutConstants.PROXIMA_PAGINA,
        }}
        onPageChange={onChangePage}
        onRowsPerPageChange={onChangeRowsPerPage}
        ActionsComponent={PaginationActions}
        labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
      />
    </>
  );
}

export default memo(TabelaValidarProcessos);
